import { Component, OnInit, Input } from '@angular/core';
import * as $ from "jquery";
@Component({
  selector: 'app-managers-and-agents-list',
  templateUrl: './managers-and-agents-list.component.html',
  styleUrls: ['./managers-and-agents-list.component.css']
})
export class ManagersAndAgentsListComponent implements OnInit {

  @Input() nameManagersAndAgents: any;
  newSaleSumm: number = 0;
  salesVolumeSumm: number = 0;
  activeAgentsSumm: number = 0;
  isActive: boolean = true;
  constructor() { }

  ngOnInit() {
    
  }

  ngOnChanges(){
    if(this.nameManagersAndAgents.ag_tree != undefined){
      let newSale = 0;
      let salesVolume = 0;
      let activeAgents = 0;
      for(let summ of this.nameManagersAndAgents.ag_tree){
        if(summ.new_business_count != undefined){
          this.newSaleSumm = this.newSaleSumm + summ.new_business_count;
        }
	  this.salesVolumeSumm = this.salesVolumeSumm + summ.volume;
	  
		if( summ.agents != undefined){
			for(let ag of summ.agents){
			if(ag.active_agent == 1){
				this.activeAgentsSumm = this.activeAgentsSumm + 1;
			}
		}
	  
	  }
       
      }
      
    }
  }

  toggle(event){
    var element = <HTMLElement>event.target.parentNode;
    var elementTable = element.parentNode;
    var eventNameAgent = element.children[0].innerHTML;
    var agent = this.nameManagersAndAgents.ag_tree.filter(agentName=> agentName.name == eventNameAgent);
    var showContent = element.nextElementSibling.id;
    if(agent.length > 0){
      if (!element.classList.contains('active')) {
        element.classList.add('active');
        if(showContent == 'show')
        for(let i=1; i <= elementTable.children.length; i++){
          elementTable.children[i].classList.remove('show')
        }
      } else if (element.classList.contains('active')) {
        element.classList.remove('active');
        if(showContent == 'show')
        for(let i=1; i <= elementTable.children.length; i++){
          elementTable.children[i].classList.add('show')
        }
      }
    } else
      return
  }
}
